import { render, staticRenderFns } from "./StandardHeader.vue?vue&type=template&id=27e9bdf1&scoped=true"
import script from "./StandardHeader.vue?vue&type=script&lang=js"
export * from "./StandardHeader.vue?vue&type=script&lang=js"
import style0 from "./StandardHeader.vue?vue&type=style&index=0&id=27e9bdf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e9bdf1",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/StandardHeader.vue
// module id = 238
// module chunks = 0